export const urlConstants = Object.freeze({
    NODE_ENV_TEST_URL: 'https://seedmain.seedinternaldev.xyz/api/1',
    // NODE_ENV_TEST_URL: 'http://localhost:4922/api/1',
    NODE_ENV_PROD_URL: 'https://agency.massic.io/api/1',
    NODE_ENV_Localhost_URL: 'http://localhost:4922/api/1',
    CORE_ENV_TEST_URL: 'https://seedcore.seedinternaldev.xyz/api',
    CORE_ENV_PROD_URL: 'https://core.massic.io/api',
    CopyRights: `Copyrights @ Kanahiku LLC ${new Date().getFullYear()}.`,
    TEST_AI_CHATBOT_URL: 'https://reviewai.seedinternaldev.xyz',
    SessionTimeout: 3 * 60 * 60 * 1000,
    ENV_URL: 'https://massic.io', //http://localhost:3000 or https://www.seedinternaldev.xyz //https://massic.io 
    AI_API_KEY: 'sk-proj-J3DiIDImJmJ6LuCnkcxCT3BlbkFJOe6mOPcgxsZD0W5gKvac',
    CLIENT_ID: '169817861687-filla3j72lhhb30aiunr6sbiq9pnga3k.apps.googleusercontent.com', 
    // massicprod- 169817861687-filla3j72lhhb30aiunr6sbiq9pnga3k.apps.googleusercontent.com  
    //137948605480-56kn6b8a8ti77d95qu3usknlanq05fsj.apps.googleusercontent.com
    MASSIC_VERSION: "massic v1.1.0",
    DOMAIN: "Massic.io", //SeedInternal.dev //Massic.io
    SENDER_EMAIL_ID: "hello@updates.massic.io",  //hello@updates.massic.io   rajkumar@kanahiku.com
    Sign_Key: 'KdI5vZr2GXOdZ2dAkUOu5Q==',
    WEB_TOOL_URL: "http://massic-core-utilities-alp-861974577.us-west-2.elb.amazonaws.com/api/workflows/upload",
    WEB_TOOL_WEB_SOCKET_URL: "ws://massic-core-utilities-alp-861974577.us-west-2.elb.amazonaws.com",
    PROMPT_URL: "https://infer.massic.io/v1",
    ALLOWED_HOSTNAMES: ["www.seedinternaldev.xyz","massic.io", "seedinternaldev.xyz","www.massic.io", "localhost"],   //, "localhost" "www.seedinternaldev.xyz" "massic.io"
    VAPIDKEY: "BF_3h614XeLHdIOnoojqDqf7Hk5Or3yoKgJhfFI_PKKkUxcmYxEXLHgg-o8Ds_vy-xbUmpKO27aPdY1MsFnvpII",
    FORDOMAIN: "https://www.google.com/s2/favicons?domain=",
                //BF_3h614XeLHdIOnoojqDqf7Hk5Or3yoKgJhfFI_PKKkUxcmYxEXLHgg-o8Ds_vy-xbUmpKO27aPdY1MsFnvpII  -PROD
               // BK1KLGvUQ602zcedceVPvoxTybmDrmecvP4yntrfMJGQdrLLtrod5iS64e0NOknlv4g1d3ZOlEzeJRWZAphx1SU -TEST
})
  

